import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import api from "@/lib/api";
import { PageHero, Loading, Empty } from "@/components/common";

export default function Proposals() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/proposals").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);

  return (
    <div data-testid="proposals-page">
      <PageHero label="Propuestas" title="Convierte la crítica en soluciones"
        subtitle="Propuestas de política pública con problema, evidencia, costo, impacto, riesgos, comparación internacional y apoyo ciudadano." />
      <div className="max-w-6xl mx-auto px-6 py-12">
        {items === null ? <Loading /> : items.length === 0 ? <Empty /> : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {items.map((p) => (
              <Link key={p.id} to={`/propuestas/${p.id}`} data-testid={`proposal-card-${p.id}`}
                className="block bg-white rounded-lg border border-slate-200 p-6 hover:shadow-md hover:-translate-y-1 transition-all duration-200">
                {p.theme && <span className="text-xs font-semibold text-cyan-600 uppercase tracking-wide">{p.theme}</span>}
                <h3 className="font-heading font-bold text-xl text-slate-900 mt-2 mb-2">{p.title}</h3>
                <p className="text-slate-600 text-sm line-clamp-2 mb-4"><strong>Problema:</strong> {p.problem}</p>
                <div className="flex items-center gap-2 text-rose-500 font-semibold text-sm">
                  <Heart className="w-4 h-4 fill-current" /> {p.supports} apoyos
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
